/* Draft presentation-only punctuation cleanup. Never changes product records or URLs. */
/* Approved product ingredient disclosure. Keeps the original ingredient text
   intact and supports descriptions inserted after the product page loads. */
(() => {
  if (!location.pathname.startsWith('/products/')) return;
  function start() {
    const root = document.querySelector('[id^="ProductInfo-"]');
    if (!root) return;
    const bound = new WeakSet();
    function bindIndicator(details) {
      if (bound.has(details)) return;
      const icon = details.querySelector(':scope > summary > span[aria-hidden="true"]');
      if (!icon) return;
      bound.add(details);
      const update = () => {
        const value = details.open ? '\u2212' : '+';
        if (icon.textContent !== value) icon.textContent = value;
      };
      details.addEventListener('toggle', update);
      update();
    }
    function wrap() {
      root.querySelectorAll('.rte h2,.rte h3,.rte h4').forEach(heading => {
        if (!/^full ingredients\s*:?$/i.test(heading.textContent.trim())) return;
        if (heading.closest('summary')) return;
        const first = heading.nextElementSibling;
        if (!first) return;
        if (first.tagName === 'DETAILS') { bindIndicator(first); return; }
        if (/^H[1-6]$/.test(first.tagName)) return;
        const details = document.createElement('details');
        details.dataset.usaIngredients = 'true';
        const summary = document.createElement('summary');
        summary.style.cssText = 'cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;padding:10px 0';
        const plus = document.createElement('span');
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        plus.style.cssText = 'flex:none;margin-left:16px;font-size:24px;line-height:1';
        summary.append(plus);
        details.append(summary);
        let next = first;
        while (next && !/^H[1-6]$/.test(next.tagName)) {
          const after = next.nextElementSibling;
          details.append(next);
          next = after;
        }
        heading.before(details);
        heading.style.margin = '0';
        heading.style.flex = '1';
        summary.prepend(heading);
        bindIndicator(details);
      });
    }
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; wrap(); });
    }).observe(root, {childList:true, subtree:true});
    wrap();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

(() => {
  const excluded = 'script,style,textarea,input,code,pre,noscript,svg,[contenteditable="true"]';
  function clean(root) {
    if (root.nodeType === 1 && root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement || node.parentElement.closest(excluded)) continue;
      const before = node.nodeValue;
      if (!/—|--/.test(before)) continue;
      node.nodeValue = before.replace(/\s*(?:—|--+)\s*/g, ', ').replace(/,\s*([.,;:!?])/g, '$1');
    }
  }
  function start() {
    clean(document.body);
    // Only process newly inserted fragments, never rescan the page on scroll.
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1) clean(node);
      }
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

/* Equal collection title space without clipping names. Recalculate only when
   content or width changes, never on scroll or on our own style writes. */
(() => {
  if (!location.pathname.startsWith('/collections/')) return;
  let pending = false;
  function align() {
    pending = false;
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    const titles = [...grid.querySelectorAll('.product-card > .card__content > .card__information > .card__heading')];
    const height = Math.ceil(Math.max(0, ...titles.map(title => title.querySelector('a')?.offsetHeight || 0)));
    if (height) grid.style.setProperty('--usa-collection-title-height', height + 'px');
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(align); } }
  function start() {
    const root = document.querySelector('#MainContent');
    if (!root) return;
    new MutationObserver(schedule).observe(root, {childList:true, subtree:true, characterData:true});
    let width = 0;
    new ResizeObserver(entries => {
      const next = entries[0].contentRect.width;
      if (next !== width) { width = next; schedule(); }
    }).observe(root);
    document.fonts?.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
/* Reputon's embedded confirmation is populated after the form loads. Keep its
   wording, removing only the unwanted trailing frown on our feedback page. */
(() => {
  if (!location.pathname.startsWith('/apps/reputon-reviews/feedback/')) return;
  const selector = '[data-localize="sorryForExperience"]';
  function tidyConfirmation() {
    document.querySelectorAll(selector).forEach(heading => {
      const text = heading.textContent;
      const clean = text.replace(/\s*[;:]\(\s*$/, '');
      if (clean !== text) heading.textContent = clean;
    });
  }
  function start() {
    const main = document.querySelector('main');
    if (!main) return;
    tidyConfirmation();
    new MutationObserver(tidyConfirmation).observe(main, {
      childList: true, subtree: true, characterData: true
    });
    document.addEventListener('reputonFormLoaded', tidyConfirmation);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
